module.exports = __webpack_public_path__ + "fd2b98d14d3e7b934116b5970ddbc4e4.pdf";